import React, { createContext, useContext } from "react";

/**
 * Import Packages
 */
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

/**
 * Initialize our Firebase App
 */
const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASEAPIKEY,
  authDomain: process.env.REACT_APP_FIREBASEAUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASEPROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASESTORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASEMESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASEAPPID,
  measurementId: process.env.REACT_APP_FIREBASEMEASUREMENTID,
});

/**
 * Create Context for Provider
 */
export const FirestoreContext = createContext();

/**
 * Hook for Firestore Context
 *
 * @returns Context
 */
export function useFirestore() {
  return useContext(FirestoreContext);
}

/**
 *
 * @param {Object} props
 * @returns
 */
export const FirestoreProvider = ({ children }) => {
  const db = getFirestore(app);

  /**
   *
   */
  return (
    <FirestoreContext.Provider
      value={{
        db,
      }}
    >
      {children}
    </FirestoreContext.Provider>
  );
};
